const buttonClass = { active: 'is-white', default: 'is-grey-3' }

export default class {
  constructor() {
    const components = document.querySelectorAll(
      '[data-component="section-filter"]'
    )

    if (!components) return
    components.forEach((element) => {
      this.initComponent(element)
    })
  }

  initComponent(element) {
    const boxes = element.querySelectorAll('[data-filter]')
    const carousel = element.querySelector('.swiper')
    let active = element.querySelector('.button[data-slug].is-white')

    element.addEventListener('click', (e) => {
      const btn = e.target.closest('.button[data-slug]')

      if (btn && btn != active) {
        active.classList.remove(buttonClass.active)
        active.classList.add(buttonClass.default)

        btn.classList.remove(buttonClass.default)
        btn.classList.add(buttonClass.active)

        active = btn

        boxes.forEach((box) => {
          const tags = box.dataset.filter.split(' ')
          const slug = btn.dataset.slug

          const target = box.closest(carousel ? '.swiper-slide' : '.column')

          target.classList.toggle(
            'is-hidden',
            !tags.includes(slug) && slug.length
          )
        })

        if (carousel) carousel.swiper.update()
      }
    })
  }
}
